import { render, staticRenderFns } from "./SearchLabelBody.vue?vue&type=template&id=d9d5c2a4&scoped=true"
import script from "./SearchLabelBody.vue?vue&type=script&lang=js"
export * from "./SearchLabelBody.vue?vue&type=script&lang=js"
import style0 from "./SearchLabelBody.vue?vue&type=style&index=0&id=d9d5c2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d5c2a4",
  null
  
)

export default component.exports